export const latestRequestIds: Record<
  'steps' | 'columns' | 'rows' | 'rowsCount',
  Maybe<string>
> = {
  steps: undefined,
  columns: undefined,
  rows: undefined,
  rowsCount: undefined,
};
